<template>
  <div :class="`dashboard-graph-wrapper${currentMetric === metric ? ' active-graph' : ''}`">
    <div class="previos-btn-wrapper">
      <button class="btn btn-transparent-bkg" @click="changeToPreviousMetric()">
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
      </button>
    </div>
    <div class="next-btn-wrapper">
      <button class="btn btn-transparent-bkg" @click="changeToNextMetric()">
        <i class="fas fa-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
    <donut-chart 
      :colors="chartColors"
      :chartValue="chartValue"
      :maxValue="maxValue"
    />

    <metric-info 
      :session-metrics="METRICS"
      :metric="metric" 
      :value="chartValue"
      :current-metric="currentMetric"
      :change-selected-metric="onChangeSelectedMetric"
      currentPage="dashboard"
    />
  </div>
</template>

<script>
import { SESSION_METRICS } from '@/constants/SessionConsts';
import DonutChart from '@/components/charts/DonutChart';
import MetricInfo from '@/components/calendar-activity/MetricInfo';

export default {
  name: 'ChartTab',
  props: {
    chartColors: Array,
    maxValue: Number,
    chartValue: Number,
    label: String,
    currentMetric: String,
    metric: String,
    changeSelectedMetric: Function
  },
  data () {
    return {
      METRICS: SESSION_METRICS
    }
  },
  methods: {
    onChangeSelectedMetric (metric) {
      this.$eventHub.$emit('dashboard-page-updated');
      this.changeSelectedMetric(metric);
    },
    changeToNextMetric () {
      switch(this.currentMetric) {
        case SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR:
          this.onChangeSelectedMetric(SESSION_METRICS.AP);
          break;
        case SESSION_METRICS.AP:
          this.onChangeSelectedMetric(SESSION_METRICS.WORKLOAD);
          break;
        case SESSION_METRICS.WORKLOAD:
          this.onChangeSelectedMetric(SESSION_METRICS.DISTANCE);
          break;
        case SESSION_METRICS.DISTANCE:
          this.onChangeSelectedMetric(SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR);
          break;
      }
    },
    changeToPreviousMetric () {
      this.$eventHub.$emit('dashboard-page-updated');

      switch(this.currentMetric) {
        case SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR:
          this.onChangeSelectedMetric(SESSION_METRICS.DISTANCE);
          break;
        case SESSION_METRICS.DISTANCE:
          this.onChangeSelectedMetric(SESSION_METRICS.WORKLOAD);
          break;
        case SESSION_METRICS.WORKLOAD:
          this.onChangeSelectedMetric(SESSION_METRICS.AP);
          break;
        case SESSION_METRICS.AP:
          this.onChangeSelectedMetric(SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR);
          break;
      }
    }
  },
  components: {
    DonutChart,
    MetricInfo
  }
}
</script>

<style lang="scss" scoped>
  .previos-btn-wrapper, .next-btn-wrapper {
    display: none;
    position: absolute;
    height: 30px;
    top: 0;
    bottom: 0;
    margin: auto;
    background: transparent;
  }

  .dashboard-graph-wrapper {
    position: relative;

    .previos-btn-wrapper, .next-btn-wrapper {
      display: none;
      position: absolute;
      height: 30px;
      top: 0;
      bottom: 0;
      margin: auto;
      background: transparent;
    }

    .previos-btn-wrapper {
      left: 0;
    }

    .next-btn-wrapper {
      right: 0;
    }

    .chart {
      min-height: 320px;
    }

    .metric-statistics {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;

      .metric-cell-wrapper {
        display: table;
        width: 100%;
        height: 100%;

        .metric-cell {
          display: table-cell;
          vertical-align: middle;
          text-align: center;
        }
      }
    }

    .info-btn-wrapper {
      position: absolute;
      right: 20px;
      top: 0;

      .static {
        display: inline-block;
      }

      .hover {
        display: none;
      }

      &:hover {
        .static {
          display: none;
        }
  
        .hover {
          display: inline-block;
        }
      }
    }
  }

  @media screen and (max-width: 992px) { 
    .dashboard-graph-wrapper {
      margin-bottom: 40px;
    }
  }

  @media screen and (max-width: 768px) { 
    .dashboard-graph-wrapper {
      display: none;

      &.active-graph {
        display: block;
        margin-bottom: 0;
      }

      .previos-btn-wrapper, .next-btn-wrapper {
        display: inline-block !important;
        z-index: 9;

        .btn:hover, .btn:focus {
          color: $white;
        }
      }

      .info-btn-wrapper {
        right: -20px !important;
      }
    }
  }
</style>
